module.exports = __webpack_public_path__ + "778d0c1f93d3385646334dc7231c03ed.pdf";